import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import * as Device from 'react-device-detect';

import { ShareMenu } from '../../common';
import EditOptions from './EditOptions';
import { HeaderProps } from './types';
import { EventCoverDialog } from '../event-form';
import { EditMode } from './EditMode';

function MobileHeader(props: Readonly<HeaderProps>) {
  const { id, covers, isOwner, handleBack } = props;
  const theme = useTheme();
  const { t } = useTranslation('cta');
  const { isLandscape } = Device.useMobileOrientation();

  return (
    <Box>
      <AppBar position="fixed" elevation={0}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Stack direction="row" onClick={handleBack} sx={{ cursor: 'pointer' }}>
            <theme.icons.back />
            <Typography> {t('back')}</Typography>
          </Stack>
          <Stack direction="row" spacing={2} alignItems={'center'} pr={1}>
            {isOwner && <EditMode />}
            <ShareMenu type="event" idOrSlug={id} />
            {isOwner && <EditOptions eventId={id} />}
          </Stack>
        </Toolbar>
      </AppBar>

      <Stack position="relative" pt={`${theme.mixins.toolbar.minHeight}px`}>
        <EventCoverDialog />
        {/* SLIDER */}
        <Swiper
          className="mySwiper"
          modules={[Navigation, Pagination]}
          pagination={{ clickable: true, type: 'progressbar' }}
          navigation={isLandscape}
          loop={covers.length > 1}
          style={{ width: '100%', aspectRatio: '4/3' }}
        >
          {covers.length > 0 &&
            covers.map((cover) => (
              <SwiperSlide key={cover.id} style={{ width: '100%' }}>
                <img
                  src={cover.url}
                  alt="img"
                  style={{ width: '100%', objectFit: 'cover', objectPosition: 'center', aspectRatio: '4/3' }}
                />
              </SwiperSlide>
            ))}
          {covers.length === 0 && (
            <SwiperSlide style={{ width: '100%' }}>
              <Stack
                pt={3}
                width="100%"
                height="100%"
                justifyContent="center"
                alignItems="center"
                sx={{
                  backgroundColor: '#000',
                }}
              >
                <theme.icons.noImage />
              </Stack>
            </SwiperSlide>
          )}
        </Swiper>
      </Stack>
    </Box>
  );
}

export default MobileHeader;
